import React from 'react';
import { useHistory } from 'react-router-dom';
import { Box, Card, CardContent, Typography } from '@mui/material';
import MobileLayout from './MobileLayout';

const MobileHome: React.FC = () => {
  const history = useHistory();

  return (
    <MobileLayout>
      <Typography variant="h5" gutterBottom sx={{ mt: 2 }}>
        Mobile
      </Typography>
      <Box display="flex" flexDirection="column" gap={2}>
        <Card sx={{ cursor: 'pointer' }} onClick={() => history.push('/mobile/pick')}>
          <CardContent>
            <Typography variant="h6">Run Pick Wave</Typography>
            <Typography variant="body2" color="text.secondary">
              Start or resume a fulfillment pick wave
            </Typography>
          </CardContent>
        </Card>
      </Box>
    </MobileLayout>
  );
};

export default MobileHome;
